


































import { ElTable } from "element-ui/types/table";
import { Mixins, Component, Prop, Watch, Emit } from "vue-property-decorator";
import { ILineGraphPair, ILineGraphLinkedObjectSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { IFormatObjectEditable } from "../../../../../../../formatEditor/domain/editableFormat";

@Component
export default class LineGraphPairSelector extends Mixins() {
  @Prop({ default: "名称" })
  label: string;

  @Prop({ default: () => [] as ILineGraphPair[] })
  items: ILineGraphPair[];

  @Prop({ default: () => [] as { pageKey: number, object: IFormatObjectEditable }[] })
  selectionObjects: { pageKey: number, object: IFormatObjectEditable }[];

  @Prop({ type: Function, default: () => "" })
  toPageNumberCellString: (row: ILineGraphLinkedObjectSpecifiable) => string;

  $refs!: {
    table: ElTable,
  };

  toTimeAxisKeyString(row: ILineGraphPair): string {
    return this.toKeyString(row.timeAxis);
  }

  toValueKeyString(row: ILineGraphPair): string {
    return this.toKeyString(row.value);
  }

  private toKeyString(row: ILineGraphLinkedObjectSpecifiable): string {
    const formatObject = this.getFormatObjectEditable(row);
    return formatObject && formatObject.object.getIdentifiableName()
      ? formatObject.object.getIdentifiableName()
      : row.key;
  }

  private getFormatObjectEditable(row: ILineGraphLinkedObjectSpecifiable): { pageKey: number, object: IFormatObjectEditable } {
    return this.selectionObjects.find(v => {
      const linkedObject = v.object.toLinkedObjectIdentifier();
      return v.pageKey === row.page &&
        linkedObject.type === row.type &&
        linkedObject.id === row.id &&
        linkedObject.key === row.key &&
        linkedObject.subKey === row.subKey &&
        linkedObject.isDate === row.isDate;
    });
  }

  @Watch("items")
  onItemsUpdated(newValue: ILineGraphPair[], oldValue: ILineGraphPair[]) {
    // element-uiのテーブルにスクロールバーが表示される際、ヘッダがずれる問題に対応するため、dataプロパティ更新時に遅延でdoLayoutを呼び出す
    this.$nextTick(() => this.$doWhenValid(t => t.doLayout(), this.$refs.table));
  }

  @Emit()
  selectionChange(value: ILineGraphPair[]): void {}
}
